import { inject, Injectable, signal } from '@angular/core';
import { finalize, Observable, tap } from 'rxjs';
import {
  EmployeeNotificationSettingsDto,
  ProfileService,
} from '../../../api/gen';

@Injectable({ providedIn: 'root' })
export class NotificationSettingsDataService {
  private readonly api = inject(ProfileService);
  readonly settings = signal<EmployeeNotificationSettingsDto | null>(null);
  readonly loading = signal(false);
  readonly failed = signal(false);

  load(force = false): void {
    if (this.loading() || (this.settings() && !force)) return;
    this.loading.set(true);
    this.failed.set(false);
    this.api
      .profileNotificationSettingsGet()
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: (settings) => this.settings.set(settings),
        error: () => this.failed.set(true),
      });
  }

  update(
    settings: EmployeeNotificationSettingsDto,
  ): Observable<EmployeeNotificationSettingsDto> {
    return this.api
      .profileNotificationSettingsPatch(settings)
      .pipe(tap((saved) => this.settings.set(saved)));
  }
}
